// src/components/portal/FeatureLocked.js
import React, { useState } from 'react';
import { useLanguage } from '../../context/LanguageContext';
import { C } from '../../styles/theme';

// ─── Brand tokens ─────────────────────────────────────────────────────────────
const FONT = "'Plus Jakarta Sans', sans-serif";

const LockIcon = ({ size = 28 }) => (
    <svg
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        stroke={C.green}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
    >
        {/* shackle arc */}
        <path d="M8 11V7a4 4 0 0 1 8 0v4" />
        {/* lock body */}
        <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
    </svg>
);

const FeatureLocked = ({ feature, requiredPlan = 'Pro', title, onUpgrade }) => {
    const { t } = useLanguage();
    const [hovered, setHovered] = useState(false);

    const handleClick = () => {
        if (typeof onUpgrade === 'function') onUpgrade(feature);
    };

    return (
        <div
            style={{
                minHeight: '100%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                background: C.bg,
                padding: '48px 24px',
                fontFamily: FONT,
            }}
        >
            <div
                style={{
                    background: C.white,
                    maxWidth: 480,
                    width: '100%',
                    border: `1px solid ${C.border}`,
                    borderRadius: 16,
                    padding: 40,
                    boxShadow: '0 1px 3px rgba(0,0,0,0.06)',
                    textAlign: 'center',
                }}
            >
                {/* Lock icon circle */}
                <div
                    style={{
                        width: 64,
                        height: 64,
                        borderRadius: '50%',
                        background: C.greenLight,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        margin: '0 auto',
                    }}
                >
                    <LockIcon size={28} />
                </div>

                {/* Plan badge */}
                <div style={{ marginTop: 20 }}>
                    <span
                        style={{
                            display: 'inline-block',
                            background: C.greenLight,
                            color: C.greenDark,
                            border: `1px solid ${C.greenBorder}`,
                            borderRadius: 999,
                            padding: '4px 12px',
                            fontSize: 11,
                            fontWeight: 700,
                            letterSpacing: 0.6,
                            textTransform: 'uppercase',
                            fontFamily: FONT,
                        }}
                    >
                        {requiredPlan}
                    </span>
                </div>

                {/* Heading */}
                <h2
                    style={{
                        fontSize: 20,
                        fontWeight: 800,
                        color: C.text,
                        margin: '16px 0 8px',
                        fontFamily: FONT,
                    }}
                >
                    {title || t('feature_locked_title')}
                </h2>

                {/* Body */}
                <p
                    style={{
                        fontSize: 14,
                        color: C.muted,
                        lineHeight: 1.6,
                        maxWidth: 360,
                        margin: '0 auto',
                        fontFamily: FONT,
                    }}
                >
                    {t('feature_locked_body')}
                </p>

                {/* CTA button */}
                <button
                    onClick={handleClick}
                    onMouseEnter={() => setHovered(true)}
                    onMouseLeave={() => setHovered(false)}
                    style={{
                        marginTop: 24,
                        background: hovered ? C.greenDark : C.green,
                        color: C.white,
                        border: 'none',
                        borderRadius: 8,
                        padding: '11px 22px',
                        fontSize: 14,
                        fontWeight: 700,
                        cursor: 'pointer',
                        fontFamily: FONT,
                        transition: 'background 0.15s',
                    }}
                >
                    {t('upgrade_plan')}
                </button>
            </div>
        </div>
    );
};

export default FeatureLocked;
